import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import SuiteFeatureTableHeaderCell from '../feature-table/SuiteFeatureTableHeaderCell';
import CompareProFeatureTableHeaderCell from './CompareProFeatureTableHeaderCell';
export const headerHeight = '155px';
const commonStyles = css(["width:100%;z-index:100;height:", ";"], headerHeight);
const FullWidthContainer = styled.tbody.withConfig({
  displayName: "SuiteFeatureTableStickyHeader__FullWidthContainer",
  componentId: "vora05-0"
})(["", " position:", ";top:0;display:block;left:0;background-color:", ";box-shadow:inset 0 4px 4px rgba(124,152,182,0.2);filter:drop-shadow(0 4px 4px rgba(124,152,182,0.2));"], commonStyles, ({
  isSuiteStarterPage
}) => isSuiteStarterPage ? 'fixed' : 'absolute', GYPSUM); //top property is dependent on sticky nav height

const StickyHeaderTable = styled.table.withConfig({
  displayName: "SuiteFeatureTableStickyHeader__StickyHeaderTable",
  componentId: "vora05-1"
})(["", " position:", ";top:", ";display:", ";table-layout:fixed;margin:0;max-width:", ";"], commonStyles, ({
  isLearnMoreModal
}) => isLearnMoreModal ? 'sticky' : 'fixed', ({
  isLearnMoreModal,
  isSuiteStarterPage
}) => isLearnMoreModal ? '-60px' : isSuiteStarterPage ? 0 : '62px', ({
  visible
}) => visible ? 'table' : 'none', ({
  width
}) => `${width}px`);
const THead = styled.thead.withConfig({
  displayName: "SuiteFeatureTableStickyHeader__THead",
  componentId: "vora05-2"
})(["position:relative;height:inherit;z-index:101;tr{display:table-row;vertical-align:bottom;}tr th{border:1px solid ", ";}"], KOALA);

const SuiteFeatureTableStickyHeader = ({
  levels,
  tableRef,
  isSuiteStarterPage,
  isLearnMoreModal,
  isComparePro,
  levelsAndApiNames
}) => {
  const [showHeader, setShowHeader] = useState(false);
  const [headerWidth, setHeaderWidth] = useState(0);

  const handleScroll = () => {
    if (tableRef && tableRef.current) {
      const tableRect = tableRef.current.getBoundingClientRect();
      const {
        top,
        bottom,
        width
      } = tableRect;
      const shouldShowHeader = !!(top <= (isComparePro ? 90 : 350) && bottom > 200);
      setShowHeader(shouldShowHeader);
      setHeaderWidth(width);
    }
  };

  const handleResize = () => {
    if (tableRef && tableRef.current) {
      const tableRect = tableRef.current.getBoundingClientRect();
      setHeaderWidth(tableRect.width);
    }
  };

  useEffect(() => {
    const targetElement = isLearnMoreModal ? document.querySelector('[data-component-name="UIModalDialog"]') || window : window;
    targetElement.addEventListener('scroll', handleScroll);
    return targetElement.addEventListener('scroll', handleScroll); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLearnMoreModal]);
  useEffect(() => {
    const targetElement = isLearnMoreModal ? document.querySelector('[data-component-name="UIModalDialog"]') || window : window;
    targetElement.addEventListener('resize', handleResize);
    return () => targetElement.removeEventListener('resize', handleResize); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLearnMoreModal]);
  return /*#__PURE__*/_jsxs(StickyHeaderTable, {
    visible: showHeader,
    width: headerWidth,
    "data-selenium": "suite-feature-table-header",
    isLearnMoreModal: isLearnMoreModal,
    isSuiteStarterPage: isSuiteStarterPage || isComparePro,
    children: [/*#__PURE__*/_jsx(THead, {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {}), isComparePro && levelsAndApiNames ? levelsAndApiNames.map(item => {
          return /*#__PURE__*/_jsx(CompareProFeatureTableHeaderCell, {
            productLevel: item.level,
            columns: levelsAndApiNames.length,
            productLine: item.productLine,
            isStaticHeader: false
          }, item.level);
        }) : levels.map(level => {
          return /*#__PURE__*/_jsx(SuiteFeatureTableHeaderCell, {
            productLevel: level,
            columns: levels.length,
            isSuiteStarterPage: isSuiteStarterPage,
            isLearnMoreModal: isLearnMoreModal
          }, level);
        })]
      })
    }), /*#__PURE__*/_jsx(FullWidthContainer, {
      isSuiteStarterPage: isSuiteStarterPage
    })]
  });
};

export default SuiteFeatureTableStickyHeader;